<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* html body{
  width: 100%;
  height: 100%;
 
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

   width: 100%;
  height: 100%;
} */

body {
    margin: 0;
    padding: 0;
    height: 100%;
    background-color: var(--primary-color);
    font-family:”Microsoft YaHei”,Arial,Helvetica,sans-serif,”宋体”;
    white-space: nowrap;
}
html{
    height: 100%;
}
#app {
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue